import { abortableFetch, useEventCallback } from '@eas/common-web';
import { AccessoryParticipant } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEditAccessoryParticipantDialog() {
  const callApi = useEventCallback(
    (id: string, proposerId: string, formData: AccessoryParticipant) => {
      return abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/${id}/participant/${proposerId}`,
        {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(formData),
        }
      );
    }
  );

  return {
    callApi,
  };
}
